/* eslint-disable prefer-const */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
import React, {
  useState,
  useCallback,
  useEffect,
  useRef,
  memo,
  useMemo,
  useContext,
  forwardRef,
  useImperativeHandle
} from "react";

import plusImg from "../../../../assets/images/homepage/ySafe/tableIcons/Plus.svg";
// import nodata from "assets/images/homepage/setting/No data.svg";

import Button from "components/Button/index";
import useTheme from "hooks/observer";
import SortIcons from "../../../../constants/Homepage/ysafe/iconFunctions/sortIcons";
import "../FilesWrapper/fileWrapper.scss";
import Dropdown from "components/DropDowns/customDropDown/index";
// import Table from "../table/index";
import useScreenMobile from "hooks/useScreen";
import GetActionIcon from "constants/Homepage/ysafe/iconFunctions/getActionIcon";
import Input from "components/Input/index";
import TextDropDown from "components/DropDowns/TextDropDowns/index";
import Drawer from "components/Drawer/index";
import Modal from "components/Models/index";
import UploadFileContent from "../UploadFileContent";
import { signInContext } from "context/SigninContext";
import UploadDropDown from "components/UploadDropDown/index";
import DeleteModal from "components/DeleteModal/index";
import ShareFiles from "../shareFiles/index";
import MoveFile from "components/MoveFile/index";
// import UploadFileContent from "../UploadFileContent";
import dp from "assets/images/homepage/ySafe/tableIcons/DP.svg";
import CircleLoading from "components/CircleLoading/index";
import RestoreModal from "components/RestoreModal/index";
import { useToast } from "components/Toaster/index";
import TableTest from "./TableTestExternal.jsx";
import { signupContext } from "context/SignupContext";
import { format } from "date-fns";
import { normalizeName } from "utils/normalizeName";
import { URL } from "../../../../URL/url";
import { Folder as IzFolder, sendAddPin, File as IzFile, Task, Item } from "@induz/sdk";
import { generateImageThumbnail, generateVideoThumbnail, generatePdfThumbnail } from "../../../../utils/thumbnailGenerator";
import index from "components/Card/index";

const CHUNK_TIMEOUT = 60000; // 60s per 4MB chunk
const MAX_CHUNK_RETRIES = 3;

const withTimeout = (promise, ms, label = "Operation") => {
  let timeoutId;
  const timeoutPromise = new Promise((_, reject) => {
    timeoutId = setTimeout(
      () => reject(new Error(`${label} timed out after ${ms}ms`)),
      ms
    );
  });
  return Promise.race([promise, timeoutPromise]).finally(() =>
    clearTimeout(timeoutId)
  );
};

const options = ["Name", "Type", "File Size", "Created Date", "Modified Date"];
const actionIconTitles = [
  "moveTo",
  "copy",
  "favorite",
  "download",
  "share",
  "restore",
  "delete"
];

// eslint-disable-next-line react/display-name
const FilesWrapperExternal = forwardRef(
  (
    {
      TaskMonitorVisible,
      setTaskMonitorVisible,
      filesList,
      setFilesList,
      modal,
      setModal,
      uploadModal,
      setUploadModal,
      uploadedFiles,
      setUploadedFiles,
      setIsDropDownVisible,
      isDropDownVisible,
      setShowLoadingProgress,
      showLoadingProgress,
      cancelUploadModal,
      setCancelUploadModal,
      fetchData,
      selectedFile,
      setSelectedFile,
      progress,
      setProgress,
      timeRemaining,
      setTimeRemaining,
      data,
      setCurrentPath,
      currentPath,
      path,
      checkedRows,
      setCheckedRows,
      namesArrays,
      typesArrays,
      sizeArrays,
      modifiedArrays,
      ownerArrays,
      setShowingSection,
      setShow,
      showUplodOptionsFunciton,
      uploadFolder,
      setUploadFolder,
      UUIDArrays,
      taskManager,
      searchQuery,
      setSearchQuery,
      sortSelected,
      setSortSelected,
      isSortRotated,
      setIsSortRotated,
      layout,
      setLayout,
      currentPage,
      setCurrentPage,
      totalPages,
      listedFolders,
      getReanderingList
    },
    ref
    // { isVisible, handleCancel }
  ) => {
    //   const [active, setActive] = useState(0);
    const [activeTab, setActiveTab] = useState(0);

    const [menu, setMenu] = useState({
      selectedRow: null,
      selectedOption: ""
    });

    const onChangeSection = (index) => {
      // setCheckedRows({});
      // setCurrentPath(["external_shared"]);
      // setShowingSection(index);
      // setActiveTab(index);
      // TODO: Since there is only one active tab for external spaces,deactivate this logic
    };

    useEffect(() => {
      // setSelectedFile(null);
      setProgress(0);
      setTimeRemaining(0);
      setModal(false);
    }, []);
    // const [filesData] = useState(dummyData);

    const [filesData, setFilesData] = useState([]); // test

    useEffect(() => {
      setCheckedRows({});
      // const namesArrays = JSON.parse(data?.get_obect_names());
      // const typesArrays = JSON.parse(data?.get_type());
      // check if names array is deined type
      if (!Array.isArray(namesArrays) || !Array.isArray(typesArrays) ||
        !Array.isArray(sizeArrays) || !Array.isArray(modifiedArrays) ||
        !Array.isArray(ownerArrays) || !Array.isArray(UUIDArrays)) {
        setFilesData([]);
        return;
      }
      if (namesArrays.length === 0) {
        setFilesData([]);
        return;
      }
      // console.log("inside setchecked rows and uuidsarray is ", UUIDArrays);
      const dataReceiveds = namesArrays.map((name, index) => ({
        name,
        type: typesArrays[index],
        size: sizeArrays[index],
        last_modified_date: modifiedArrays[index],
        owner: ownerArrays[index],
        uuids: UUIDArrays[index],
        fo: data?.[index] ?? null

      }));
      setFilesData(dataReceiveds);
    }, [data]);

    const [selectedModal, setSelectedModal] = useState(null);
    const [selectedRow, setSelectedRow] = useState({});
    const { storageBalance } = useContext(signupContext);

    const filteredFilesData = Object.keys(checkedRows)
      .map((id) => filesData.find((item) => item.id == id))
      .filter(Boolean);
    const filteredFilesNames = (checkedRows) => {
      const filteredFilesData = Object.keys(checkedRows)
        .map((id) => filesData.find((item) => item.id == id))
        .filter(Boolean);
      return filteredFilesData;
    };


    const sortFiles = useCallback(() => {
      if (!sortSelected) return;

      setFilesData((prevFiles) => {
        // return fetchData(currentPath, selected);
        return [...prevFiles].sort((a, b) => {
          if (sortSelected === "Type") {
            // Prioritize folders first
            const isAFolder = a.isFolder ? 1 : 0;
            const isBFolder = b.isFolder ? 1 : 0;

            if (isAFolder !== isBFolder) {
              return isBFolder - isAFolder; // Folders first
            }

            // Extract extensions, if missing set it to an empty string
            const extA = a.name.includes(".")
              ? a.name.split(".").pop().toLowerCase()
              : "";
            const extB = b.name.includes(".")
              ? b.name.split(".").pop().toLowerCase()
              : "";

            // Files without an extension should be at the top (after folders)
            if (extA === "" && extB !== "") return -1;
            if (extA !== "" && extB === "") return 1;

            // Sort by file extension
            const comparison = extA.localeCompare(extB);

            return isSortRotated ? -comparison : comparison;
          }

          let comparison = 0;
          // Compare based on the selected criteria

          if (sortSelected === "Name") {
            comparison = a.name.localeCompare(b.name);
          } else if (sortSelected === "Modified Date") {
            comparison = new Date(a.last_modified) - new Date(b.last_modified);
          } else if (sortSelected === "File Size") {
            comparison = parseFloat(a.size) - parseFloat(b.size);
          } else if (sortSelected === "Created Date") {
            comparison = new Date(a.created_at) - new Date(b.created_at);
          }

          return isSortRotated ? -comparison : comparison;
        });
      });
    }, [sortSelected, isSortRotated]);

    useEffect(() => {
      fetchData(path, sortSelected);
    }, [sortSelected, isSortRotated, sortFiles]);

    useEffect(() => {
      if (!currentPath) return;

      if (!Array.isArray(namesArrays) || !Array.isArray(typesArrays) ||
        !Array.isArray(sizeArrays) || !Array.isArray(modifiedArrays) ||
        !Array.isArray(ownerArrays)) {
        setFilesData([]);
        return;
      }
      if (namesArrays.length === 0) {
        setFilesData([]);
        return;
      }
      const newData = namesArrays.map((name, index) => ({
        name,
        type: typesArrays[index],
        size: sizeArrays[index],
        last_modified_date: modifiedArrays[index],
        owner: ownerArrays[index],
        uuids: UUIDArrays[index],
        fo: data?.[index] ?? null
      }));

      newData.sort((a, b) => {
        if (a.type === "folder" && b.type !== "folder") return -1;
        if (a.type !== "folder" && b.type === "folder") return 1;
        return 0; // Maintain relative order otherwise
      });
      setFilesData(newData);
    }, [currentPath, data]); // Dependencies: currentPath and data

    const [count, setCount] = useState(0);
    const [AddFile, setAddFile] = useState(false);

    const theme = useTheme();
    const isMobile = useScreenMobile({ size: 768 });
    const handleQUery = (e) => {
      setSearchQuery && setSearchQuery(e.target.value);
    };

    const handleSortSelect = useCallback(
      (value) => {
        setSortSelected && setSortSelected(value);
      },
      [setSortSelected]
    );

    const addNewDropDownOptions = [
      {
        title: "Create Folder",
        onClick: () => {
          // console.log("create folder clicked");
        }
      },
      {
        title: "Upload File",
        onClick: () => {
          setFilesList([]); // Clear previous files before opening new upload
          // setIsFileOpen(!isFileOpen);
          setModal(true);
        }
      },
      // {
      //   title: "Upload Folder",
      //   onClick: () => {
      //     setModal(true);
      //   }
      // }
    ];

    const handleAddFile = () => {
      setAddFile(!AddFile);
    };

    // const saveHandler = () => {
    //   setUploadModal(true);
    //   setModal(false);
    // };

    const showToast = useToast();

    useEffect(() => {
      setIsDropDownVisible(false);
    }, []);

    const dropdownRef = useRef(null);

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setAddFile(false);
        }
      };

      if (AddFile) {
        document.addEventListener("mousedown", handleClickOutside);
      }

      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [AddFile]);

    const clearHandler = () => {
      setSearchQuery && setSearchQuery("");
    };

    const hasTrueValue = Object.values(checkedRows).some((value) => value);
    const { userMail } = useContext(signInContext);
    const addPin = async () => {
      const pin = "642355";
      const token = await sendAddPin(userMail, pin);
      // console.log("token is ", token);
      return {
        token: token,
        pin: pin
      };
    };

    const uploadFile = async (file, parentPath, thumbnailPromise = null) => {
      // console.log("uploading file", file, "to path", parentPath);
      setTaskMonitorVisible(true);
      const conn_pool = [];
      const chunkSize = 4 * 1024 * 1024; // 1MB
      const totalChunks = Math.ceil(file.size / chunkSize);
      const isSmallFile = totalChunks <= 1;
      const fo = new IzFile();
      // console.log("Parentpath", parentPath);
      fo.setSize(file.size);
      fo.setParentPath(parentPath);
      const sanitizedName = normalizeName(file.name, true);
      fo.setFileName(sanitizedName);

      // batchsize should be equal to total chunks or 100 which ever is smaller
      const batchSize = Math.min(totalChunks, 20);
      if (!parentPath.endsWith("/")) parentPath += "/";
      let uploadedBytes = 0;
      const task = new Task(file.size, file.originalName || file.name, "Uploading ");
      try {
        // console.log("about to start uploading");
        taskManager.addRunningTask(task);
        await withTimeout(fo.startWrite(file.type), 30000, "startWrite");
        let offset = 0;
        // Use concurrent chunk uploads
        const maxConcurrency = 12; // Adjust as needed
        let activeUploads = 0;
        let nextOffset = 0;
        let errorOccurred = null;

        // Helper to upload a single chunk with retry
        const uploadChunk = async (start) => {
          if (errorOccurred) return;
          const chunk = file.slice(start, start + chunkSize);
          const arrayBuffer = await chunk.arrayBuffer();
          for (let attempt = 0; attempt <= MAX_CHUNK_RETRIES; attempt++) {
            try {
              await withTimeout(
                fo.putChunk(new Uint8Array(arrayBuffer), start, task, null),
                CHUNK_TIMEOUT,
                `Upload chunk at offset ${start}`
              );
              return;
            } catch (err) {
              if (attempt < MAX_CHUNK_RETRIES) {
                const delay = Math.min(1000 * Math.pow(2, attempt), 8000);
                console.warn(`Chunk upload retry ${attempt + 1}/${MAX_CHUNK_RETRIES} for offset ${start}`);
                await new Promise((r) => setTimeout(r, delay));
                continue;
              }
              errorOccurred = err;
            }
          }
        };
        // Manage a pool of concurrent uploads
        const uploadPool = [];
        let completedChunks = 0;
        const totalChunks = Math.ceil(file.size / chunkSize);

        // console.log(`File size: ${file.size}, Total chunks: ${totalChunks}`);

        while (nextOffset < file.size && !errorOccurred) {
          // Fill the upload pool up to maxConcurrency
          while (activeUploads < maxConcurrency && nextOffset < file.size) {
            const currentOffset = nextOffset;
            nextOffset += chunkSize;
            activeUploads++;

            // Create a promise that tracks completion and removes itself from pool
            const promise = uploadChunk(currentOffset)
              .then(() => {
                completedChunks++;
                // console.log(`Completed chunk ${completedChunks}/${totalChunks} (${Math.round(completedChunks / totalChunks * 100)}%)`);
              })
              .finally(() => {
                activeUploads--;
                // Remove this promise from the pool when done
                const index = uploadPool.indexOf(promise);
                if (index > -1) uploadPool.splice(index, 1);
              });

            uploadPool.push(promise);
          }

          // Wait for ANY chunk to complete before continuing
          if (uploadPool.length > 0) {
            await Promise.race(uploadPool);
            // Don't empty the pool - just let completed promises remove themselves
          }
        }

        // Wait for any remaining uploads to complete
        while (uploadPool.length > 0) {
          await Promise.race(uploadPool);
        }
        // Manage a pool of concurrent uploads

        if (errorOccurred) { console.error("error occured while uploading"); throw errorOccurred; }
        await fo.finalizeWrite(file.type, [], file.size);
        // Apply thumbnail after upload completes (generated concurrently)
        if (thumbnailPromise) {
          try {
            const thumbnailBytes = await thumbnailPromise;
            if (thumbnailBytes) {
              await fo.setThumbnail(thumbnailBytes);
            }
          } catch (thumbnailErr) {
            console.error("Failed to set thumbnail:", thumbnailErr);
          }
        }
        taskManager.addCompletedTask(task, 1);
      } catch (error) {
        taskManager.addCompletedTask(task, 2);
        if (cancelUploadModal) {
          showToast("Upload cancelled", "success");
        } else {
          console.error(`Upload failed for ${file.name}:`, error);
          showToast(`Upload failed for ${file.name}`, "error");
        }
        throw error;
      }
    };


    function extractParentAndName(path) {
      // console.log("Create folder", path);
      const lastSlash = path.lastIndexOf("/");
      if (lastSlash === -1) {
        return { parent: "", name: path };
      }
      const parent = path.substring(0, lastSlash);
      const name = path.substring(lastSlash + 1);
      return { parent, name };
    }

    async function createDirectory(total_path, formattedPath) {
      // console.log("Create folder", path);
      if (path[1] === "self" && path[0] == "shared") {
        const newPath = [...path];
        newPath.splice(1, 1);
        path = newPath;
      }
      const now = new Date();
      const formattedDateTime = format(now, "M/d/yyyy h:mm a"); // Uses Date-fns
      const { parent, name } = extractParentAndName(total_path);
      const folderLocation = parent
        ? (formattedPath.endsWith("/") ? formattedPath : formattedPath + "/") + parent
        : formattedPath;

      try {
        const root = IzFolder.getRoot();
        await root.createFolder(folderLocation, name);


        const newFolder = {
          name: name,
          type: "folder",
          files: [],
          lastModified: formattedDateTime,
          size: 0,
          owner: "You",
          filePermission: "owner"
        };

        // setUploadedFiles((prevFiles) => [...prevFiles, newFolder]);


        fetchDataWithFollowups(path);

        setIsDropDownVisible(false);
        setAddFile(false);
      } catch (error) {
        console.error("Failed to create folder:", error);
        showToast("Failed to create Folder", "error");
      }
    }
    //     async function saveHandlerForSharedFiles(selectedFiles) {
    //   setTaskMonitorVisible(true);
    //   const formattedPath = currentPath?.length === 0 ? "/" : `/${currentPath?.join("/")}`;
    //   try {
    //     setUploadModal(true);
    //     setModal(false);
    //     if (uploadFolder) {
    //       const directories = new Set();
    //       for (const file of selectedFiles) {
    //         const parts = file.webkitRelativePath.split("/");
    //         let curr = "";

    //         for (let i = 0; i < parts.length - 1; i++) {
    //           curr += (i === 0 ? "" : "/") + parts[i];
    //           directories.add(curr);
    //         }
    //       }

    //       for (const x of directories) {
    //         await createDirectory(x, formattedPath);
    //       }
    //     }

    //     const uploadPromises = [];

    //     for (const file of selectedFiles) {
    //       if (cancelUploadModal) {
    //         console.warn("Upload cancelled before starting.");
    //         showToast("Upload cancelled", "warning");
    //         break;
    //       }

    //       const path = uploadFolder
    //         ? (formattedPath.endsWith("/") ? formattedPath : formattedPath + "/") +
    //         file.webkitRelativePath.substring(0, file.webkitRelativePath.lastIndexOf("/"))
    //         : formattedPath;

    //       const uploadPromise = uploadFile(file, path).catch(error => {
    //         // Optional: handle specific error or cancellation
    //         console.error("Upload failed for", file.name, error);
    //         // Decide whether to throw or just log
    //         throw error; // if you want to halt Promise.allSettled loop later
    //       });

    //       uploadPromises.push(uploadPromise);
    //     }

    //     try {
    //       await Promise.allSettled(uploadPromises); // Or use Promise.all() to fail fast

    //     } catch (error) {
    //       console.warn("One or more uploads failed:", error);
    //     }


    //     setUploadModal(false);
    //     setSelectedFile([]);
    //     setFilesList([]);
    //     fetchDataWithFollowups(currentPath); // refresh view
    //     if (!cancelUploadModal && storageBalance > 90) {
    //       setShow(true);
    //     }

    //     // if (!cancelUploadModal) {
    //     //   showToast("Files uploaded successfully", "success");
    //     // }
    //   } catch (error) {
    //     console.error("Error occurred during upload:", error);
    //     showToast(
    //       error?.message || "Error occurred while uploading files",
    //       "error"
    //     );
    //   }
    // }


    async function saveHandler(selectedFiles) {
      setTaskMonitorVisible(true);
      window.dispatchEvent(new CustomEvent("operationStart"));
      let dupCurrentPath = currentPath;
      let pathForTeamSharing = currentPath;
      // console.log("Current Path in save handler", dupCurrentPath);
      if (dupCurrentPath.length >= 2 && dupCurrentPath[0] == "shared" && dupCurrentPath[1] == "teams") {
        const newPath = [...dupCurrentPath];
        newPath.splice(1, 3);
        dupCurrentPath = newPath;
      }
      else if (dupCurrentPath.length >= 2 && dupCurrentPath[0] == "shared") {
        const newPath = [...dupCurrentPath];
        newPath.splice(1, 1);
        dupCurrentPath = newPath;
      }
      // console.log("dupcurrent path in save handler", dupCurrentPath);
      const formattedPath = dupCurrentPath?.length === 0 ? "/" : `/${dupCurrentPath?.join("/")}`;

      try {
        setUploadModal(true);
        setModal(false);
        if (uploadFolder) {
          const directories = new Set();
          for (const file of selectedFiles) {
            const parts = file.webkitRelativePath.split("/");
            let curr = "";

            for (let i = 0; i < parts.length - 1; i++) {
              const sanitizedPart = normalizeName(parts[i], false);
              curr += (i === 0 ? "" : "/") + sanitizedPart;
              directories.add(curr);
            }
          }

          // Sort by depth so parents are created before children
          const sortedDirectories = Array.from(directories).sort(
            (a, b) => a.split("/").length - b.split("/").length
          );

          // Group by depth level for concurrent creation
          const dirsByDepth = new Map();
          for (const dir of sortedDirectories) {
            const depth = dir.split("/").length;
            if (!dirsByDepth.has(depth)) dirsByDepth.set(depth, []);
            dirsByDepth.get(depth).push(dir);
          }

          // Create directories concurrently within each depth level (batches of 10)
          const depthLevels = Array.from(dirsByDepth.keys()).sort((a, b) => a - b);
          for (const depth of depthLevels) {
            const dirsAtLevel = dirsByDepth.get(depth);
            for (let i = 0; i < dirsAtLevel.length; i += 10) {
              const batch = dirsAtLevel.slice(i, i + 10);
              await Promise.all(batch.map(x => createDirectory(x, formattedPath)));
            }
          }
        }

        const concurrencyLimit = 6;
        const activePromises = [];
        const results = [];

        for (const file of selectedFiles) {
          if (cancelUploadModal) {
            console.warn("Upload cancelled before starting.");
            showToast("Upload cancelled", "success");
            break;
          }

          while (activePromises.length >= concurrencyLimit) {
            await Promise.race(activePromises);
          }

          let uploadPath = formattedPath;
          if (uploadFolder) {
            const parts = file.webkitRelativePath.split("/");
            let sanitizedParts = [];
            for (let i = 0; i < parts.length - 1; i++) {
              sanitizedParts.push(normalizeName(parts[i], false));
            }
            const folderPath = sanitizedParts.join("/");
            uploadPath = (formattedPath.endsWith("/") ? formattedPath : formattedPath + "/") + folderPath;
          }

          // Thumbnail generation runs concurrently — doesn't block upload
          const promise = (async () => {
            const thumbnailPromise = (async () => {
              try {
                let thumbnailBlob = null;
                const ext = file.name ? file.name.split(".").pop().toLowerCase() : "";
                const isImage = file.type.startsWith("image/") || ["heic", "heif", "jpg", "jpeg", "png", "gif", "webp"].includes(ext);
                if (isImage) {
                  thumbnailBlob = await generateImageThumbnail(file);
                } else if (file.type.startsWith("video/")) {
                  thumbnailBlob = await generateVideoThumbnail(file);
                } else if (file.type === "application/pdf") {
                  try {
                    thumbnailBlob = await generatePdfThumbnail(file);
                  } catch (pdfErr) {
                    console.log("PDF thumbnail generation failed", pdfErr);
                  }
                }
                if (thumbnailBlob) return new Uint8Array(await thumbnailBlob.arrayBuffer());
              } catch (thumbsErr) {
                console.warn("Failed to generate thumbnail for", file.name, thumbsErr);
              }
              return null;
            })();

            return uploadFile(file, uploadPath, thumbnailPromise);
          })().then(
            () => {
              const idx = activePromises.indexOf(promise);
              if (idx > -1) activePromises.splice(idx, 1);
            },
            (err) => {
              console.error("Upload failed for", file.name, err);
              const idx = activePromises.indexOf(promise);
              if (idx > -1) activePromises.splice(idx, 1);
            }
          );

          activePromises.push(promise);
          results.push(promise);
        }

        await Promise.all(results);


        setUploadModal(false);
        setSelectedFile([]);
        setFilesList([]);
        fetchDataWithFollowups(currentPath); // refresh view
        // Dispatch event to update storage in real-time
        if (!cancelUploadModal) {
          window.dispatchEvent(new CustomEvent("storageUpdated"));
        }
        if (!cancelUploadModal && storageBalance > 90) {
          setShow(true);
        }

        // if (!cancelUploadModal) {
        //   showToast("Files uploaded successfully", "success");
        // }
      } catch (error) {
        console.error("Error occurred during upload:", error);
        showToast(
          error?.message || "Error occurred while uploading files",
          "error"
        );
      } finally {
        window.dispatchEvent(new CustomEvent("operationEnd"));
      }
    }


    const checkTheExistenceOfFile = async () => {

      try {
        // console.log("Checking existence of file in path", path);
        let itemInTeamSharing = false;
        let dupCurrentPath = path;
        let pathForTeamSharing = path;
        if (dupCurrentPath.length >= 2 && dupCurrentPath[0] === "shared" && dupCurrentPath[1] !== "self") {
          itemInTeamSharing = true;
        }
        // console.log("Current Path in check existence of file", dupCurrentPath);
        if (dupCurrentPath[0] === "shared" && dupCurrentPath.length >= 2) {
          const newPath = [...dupCurrentPath];
          newPath.splice(1, 1);
          dupCurrentPath = newPath;
        }
        // console.log("Path", dupCurrentPath);
        const formattedPath = dupCurrentPath?.length === 0 ? "/" : `${dupCurrentPath.join("/")}`;
        const existingFiles = [];
        const missingFiles = [];



        for (const file of selectedFile) {
          const sanitizedName = normalizeName(file.name, true);
          const fullPath = `${formattedPath}` + "/" + `${sanitizedName}`;
          // console.log("Files", file);
          // console.log("path , formattedPath is  in check the existence of file  and file.name", path, formattedPath,file.name);
          try {

            if (dupCurrentPath?.length === 1 && dupCurrentPath[0] === "external_shared") {

              //  TODO:target the nameArrays to check if there are two files with the same name...
              // console.log("inside shared folder");
              // fullPath = "/" + file.name;
              // console.log("tshareteampath",pathForTeamSharing);
              if (itemInTeamSharing) {
                pathForTeamSharing.push("teams");
                if (pathForTeamSharing.length > 2) {
                  [pathForTeamSharing[1], pathForTeamSharing[2]] = [pathForTeamSharing[2], pathForTeamSharing[1]];
                }
                pathForTeamSharing = pathForTeamSharing.join("/");
              }
              let full_path = itemInTeamSharing ? pathForTeamSharing : dupCurrentPath;
              // console.log("tshareteampath", full_path);
              // const sharedItem = await Item.getSharedItem(full_path + "/" + file.name, itemInTeamSharing);
              //  iterate through nameArrays and check the count of files with the same name
              let matchedUUID = null;
              const countOfSameNames = namesArrays.filter((fname, index) => {
                if (fname === file.name && typesArrays[index] === "file") {
                  matchedUUID = UUIDArrays[index];
                  return true;
                }
                return false;
              });
              if (countOfSameNames.length != 1) {
                // TODO:what happens during paging?(but we will restrict maximum objects in spaces so no problem)
                // error saying that ambiguity on which file to overwrite
                throw new Error("Multiple files with the same name exist. Please rename the file and try again.");
              }
              // console.log("sharedItem is ", sharedItem);
              // Assuming if the flow has come till here ,then it is a file
              // console.log("about to set file name to file uuid");
              // console.log("file uuid in hexa is ", sharedItem.getFileUuId());
              // Print the data type of file
              // console.log("file is ", file, "type:", typeof file, "constructor:", file?.constructor?.name);

              // You cannot directly change the `name` property of a native File object because it is read-only.
              // To "rename" a File, you need to create a new File instance with the desired name and the same content.

              const renamedFile = new File([file], matchedUUID, {
                type: file.type,
                lastModified: file.lastModified,
              });
              renamedFile.originalName = file.name;



              // console.log("pushing existing file in shared folder", file);
              missingFiles.push(renamedFile);


            } else {
              // console.log("inside normal folder");
              const item = await Item.getItem(fullPath, false);

              existingFiles.push(file);
            }
          } catch (err) {
            // If not found, assume file doesn't exist
            missingFiles.push(file);
          }
        }

        if (existingFiles.length > 0) {
          setUploadModal(false);
          showUplodOptionsFunciton(existingFiles);
        }

        if (missingFiles.length > 0) {
          saveHandler(missingFiles);
        }
      } catch (error) {
        console.error("Error occurred while checking file existence:", error);
        showToast(
          error?.message || "Error occurred while checking file existence",
          "error"
        );
      }

    };

    useImperativeHandle(ref, () => ({
      saveHandler
    }));


    const fetchDataWithFollowups = useCallback((path) => {
      // setFilesData([]); // Clear previous data
      fetchData(path);
    }, [fetchData]);


    const filteredFiles = filesData.filter((file) =>
      file.name.toLowerCase().includes((searchQuery || "").toLowerCase())
    );
    const [selectedFolder, setSelectedFolder] = useState("");

    return (
      <div
        className="fileWrapper"
        style={{
          backgroundColor:
            theme == "light" ? "#F8F2FD" : "var(--background-bg-dark)"
        }}
      >
        {true && <div className="fileWrapperContainer">
          {isMobile && count > 0 ? (
            <div className="actionsIconMobileBox">
              <div className="top">
                <div className="count">{count} items Selected</div>
                <div className="right" onClick={() => setCheckedRows({})}>
                  <GetActionIcon type="cross" color="var(--text-grey-strong)" />
                </div>
              </div>
              <div className="bottom">
                <div
                  className="icons"
                  style={{
                    justifyContent: activeTab + 1 == 4 ? "start" : "space-between"
                  }}
                >
                  {/* {actionIconTitles.map((title, index) => (
                  <div
                    className="iconBox"
                    key={index}
                    onClick={() => setSelectedModal(title)}
                  >
                    <GetActionIcon
                      type={title}
                      color="var(--text-grey-strong)"
                    />
                  </div>
                ))} */}

                  {actionIconTitles.map((title, index) => {
                    if (activeTab + 1 === 3 ? index > 3 : index !== 4) {
                      return (
                        <div
                          className="iconBox"
                          key={index}
                          onClick={() => setSelectedModal(title)}
                          style={{ cursor: "pointer" }}
                        >
                          <GetActionIcon
                            type={title}
                            color="var(--text-grey-strong)"
                          />
                        </div>
                      );
                    }
                  })}

                  {selectedModal === "share" ? (
                    <ShareFiles
                      handleCancel={() => setSelectedModal(null)}
                      sharedData={filteredFilesData(checkedRows)}
                      checkedRows={checkedRows}
                    />
                  ) : selectedModal === "delete" ? (
                    <DeleteModal
                      // content="Are you sure want to delete the  files permanantly?"
                      content={`Are you sure you want to delete ${filteredFilesNames(checkedRows).length} files permanently?`}
                      handleCancel={() => setSelectedModal(null)}
                    //  showHeader={}
                    />
                  ) : selectedModal === "copy" ? (
                    <MoveFile
                      copied={true}
                      // title="hello"
                      taskManager={taskManager}
                      handleCancel={() => setSelectedModal(null)}
                      rowData={selectedRow}
                      movedData={filteredFilesData}

                      selectedModal={selectedModal}
                      currentPath={currentPath}
                      fetchData={fetchDataWithFollowups}
                      setCurrentPath={setCurrentPath}
                      selectedFolder={selectedFolder}
                      checkedRows={checkedRows}
                      count={count}
                      UUIDArrays={UUIDArrays}
                      setTaskMonitorVisible={setTaskMonitorVisible}
                    />
                  ) : selectedModal === "moveTo" ? (
                    <MoveFile
                      copied={false}
                      // title="hello"
                      handleCancel={() => setSelectedModal(null)}
                      rowData={selectedRow}
                      movedData={filteredFilesData}
                      selectedModal={selectedModal}
                      currentPath={currentPath}
                      fetchData={fetchDataWithFollowups}
                      setCurrentPath={setCurrentPath}
                      selectedFolder={selectedFolder}
                      checkedRows={checkedRows}
                      count={count}
                      taskManager={taskManager}
                      setTaskMonitorVisible={setTaskMonitorVisible}
                    />
                  ) : selectedModal === "restore" ? (
                    <RestoreModal
                      handleCancel={() => setSelectedModal(null)}
                      content={`Are you sure want to restore the ${Object.values(checkedRows).filter((value) => value).length} files?`}
                      handleSave={() => {

                      }}
                    />
                  ) : null}
                </div>
              </div>
            </div>
          ) : (
            <>
              {/* <div className="fileWrapperContainerHeader">
                <h1>Files</h1>
                {!isMobile && (
                  <Button
                    title="Add"
                    type="violet"
                    width="fit-content"
                    showImage={true}
                    onClick={handleAddFile}
                  // height="fit-content"
                  />
                )}
                {AddFile && (
                  <div className="dropDown" ref={dropdownRef}>
                    {isMobile && (
                      <Drawer
                        leftButtonWith="50%"
                        rightButtonWith="50%"
                        handleCancel={() => {
                          setAddFile(false);
                        }}
                        isVisible={AddFile}
                        showFooter={false}
                        showHeader={false}
                        showCross={false}
                      >
                        <TextDropDown
                          content={addNewDropDownOptions}
                          width="100%"
                          setFilesList={setFilesList}
                          setModal={setModal}
                          setUploadedFiles={setUploadedFiles}
                          setIsDropDownVisible={setIsDropDownVisible}
                          setAddFile={setAddFile}
                          selectedFile={selectedFile}
                          setSelectedFile={setSelectedFile}
                          fetchData={fetchDataWithFollowups}
                          path={path}
                          filesWrap={true}
                          uploadFolder={uploadFolder}
                          setUploadFolder={setUploadFolder}
                        />
                      </Drawer>
                    )}
                    {!isMobile && (
                      <>
                        <TextDropDown
                          content={addNewDropDownOptions}
                          width="200px"
                          setFilesList={setFilesList}
                          setModal={setModal}
                          setUploadedFiles={setUploadedFiles}
                          setIsDropDownVisible={setIsDropDownVisible}
                          setAddFile={setAddFile}
                          selectedFile={selectedFile}
                          setSelectedFile={setSelectedFile}
                          fetchData={fetchDataWithFollowups}
                          path={path}
                          filesWrap={true}
                          uploadFolder={uploadFolder}
                          setUploadFolder={setUploadFolder}
                        />
                      </>
                    )}
                  </div>
                )}
              </div> */}
              <div className="fileWrapperContainerFilterBar">
                <div className="input">
                  <Input
                    searchIconBool={true}
                    placeholder="Search by filename or folder"
                    value={searchQuery}
                    onChange={handleQUery}
                    // bg="white"
                    // width={isMobile ? "100%" : "60%"}
                    clear={searchQuery && true}
                    // wrapWidth={isMobile ? "100%" : "70%"}
                    handleClear={clearHandler}
                    bg={theme == "light" ? "#fff" : "transparent"}
                  // width="78%"
                  />
                </div>
                <div className="sortBox">
                  <div className="sortBoxLayoutIcons">
                    <div
                      className="filesIcon"
                      style={{
                        backgroundColor:
                          layout === "grid"
                            ? "var(--fill-brand-weak)"
                            : "var(--background-bg-dark)"
                      }}
                      onClick={() => setLayout && setLayout("grid")}
                    >
                      <SortIcons
                        color={
                          theme == "light" &&
                            (layout == "grid" || layout == "table")
                            ? "#67308F"
                            : theme == "dark" &&
                              (layout == "grid" || layout == "table")
                              ? "var(--fill-brand-strong)"
                              : "var(--fill-brand-weak)"
                        }
                        type={layout === "grid" ? "layoutSelect" : "layout"}
                      />
                    </div>
                    <div
                      className="tableIcon"
                      style={{
                        backgroundColor:
                          layout === "table"
                            ? "var(--fill-brand-weak)"
                            : "var(--background-bg-dark)"
                      }}
                      onClick={() => setLayout && setLayout("table")}
                    >
                      <SortIcons
                        color={
                          theme == "light" &&
                            (layout == "grid" || layout == "table")
                            ? "#67308F"
                            : theme == "dark" &&
                              (layout == "grid" || layout == "table")
                              ? "var(--fill-brand-strong)"
                              : "var(--fill-brand-weak)"
                        }
                        type={layout === "table" ? "base" : "baseSelect"}
                      />
                    </div>
                  </div>
                  <div className="dropWrapper">
                    <Dropdown
                      options={options}
                      placeholder="Sort by"
                      arrowColor={theme === "light" ? "#555F75" : "#555F75"}
                      background={
                        theme === "light"
                          ? "var(--White,#FFF)"
                          : "var(--background-bg-dark)"
                      }
                      textColor={"var(--text-grey-strong)"}
                      itemColor={"var(--text-grey-strong)"}
                      hoveredColor={
                        theme == "light"
                          ? "var(--fill-brand-light)"
                          : "var(--fill-brand-light)"
                      }
                      selected={sortSelected}
                      setSelected={handleSortSelect}
                    />
                  </div>
                  <div
                    className="sortIcon"
                    style={{
                      backgroundColor: theme == "light" ? "#fff" : "transparent"
                    }}
                    onClick={() =>
                      setIsSortRotated && setIsSortRotated(!isSortRotated)
                    }
                  >
                    <span className={`order ${isSortRotated ? "asc" : "desc"}`}>
                      <SortIcons type="order" />
                    </span>
                  </div>
                </div>
                <div>
                  {!isMobile && (activeTab + 1 != 4) && (
                    <Button
                      title="Add"
                      type="violet"
                      width="fit-content"
                      showImage={true}
                      onClick={handleAddFile}
                    // height="fit-content"
                    />
                  )}
                  {AddFile && (
                    <div className="dropDown" ref={dropdownRef}>
                      {isMobile && (
                        <Drawer
                          leftButtonWith="50%"
                          rightButtonWith="50%"
                          handleCancel={() => {
                            setAddFile(false);
                          }}
                          isVisible={AddFile}
                          showFooter={false}
                          showHeader={false}
                          showCross={false}
                        >
                          <TextDropDown
                            content={addNewDropDownOptions}
                            width="100%"
                            setFilesList={setFilesList}
                            setModal={setModal}
                            setUploadedFiles={setUploadedFiles}
                            setIsDropDownVisible={setIsDropDownVisible}
                            setAddFile={setAddFile}
                            selectedFile={selectedFile}
                            setSelectedFile={setSelectedFile}
                            fetchData={fetchDataWithFollowups}
                            path={path}
                            filesWrap={true}
                            uploadFolder={uploadFolder}
                            setUploadFolder={setUploadFolder}
                          />
                        </Drawer>
                      )}
                      {!isMobile && (
                        <>
                          <TextDropDown
                            content={addNewDropDownOptions}
                            width="200px"
                            setFilesList={setFilesList}
                            setModal={setModal}
                            setUploadedFiles={setUploadedFiles}
                            setIsDropDownVisible={setIsDropDownVisible}
                            setAddFile={setAddFile}
                            selectedFile={selectedFile}
                            setSelectedFile={setSelectedFile}
                            fetchData={fetchDataWithFollowups}
                            path={path}
                            filesWrap={true}
                            uploadFolder={uploadFolder}
                            setUploadFolder={setUploadFolder}
                          />
                        </>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </>
          )}
          <div className="fileWrapperContainerTableBox">
            {/* <Table
                      layout={layout}
            count={count}
            setCount={setCount}
            checkedRows={checkedRows}
            setCheckedRows={setCheckedRows}
            filesData={searchQuery ? filteredFiles : dataReceived}
            searchQuery={searchQuery}
            filteredFilesData={filteredFilesData}
            // uploadedFiles={uploadedFiles}
            setFilesData={setFilesData}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
            setActiveTab={setActiveTab}
            activeTab={activeTab}
            menu={menu}
            setMenu={setMenu}
            selectedModal={selectedModal}
            setSelectedModal={setSelectedModal}
            setCurrentPath={setCurrentPath}
          /> */}

            <TableTest
              setTaskMonitorVisible={setTaskMonitorVisible}
              fetchData={fetchDataWithFollowups}
              layout={layout}
              count={count}
              setCount={setCount}
              checkedRows={checkedRows}
              setCheckedRows={setCheckedRows}
              filesData={searchQuery ? filteredFiles : filesData}
              searchQuery={searchQuery}
              selected={sortSelected}
              // filteredFilesData={Object.keys(checkedRows).length}
              filteredFilesData={filteredFilesData}
              // uploadedFiles={uploadedFiles}
              setFilesData={setFilesData}
              selectedRow={selectedRow}
              setSelectedRow={setSelectedRow}
              setActiveTab={onChangeSection}
              activeTab={activeTab}
              menu={menu}
              setMenu={setMenu}
              selectedModal={selectedModal}
              setSelectedModal={setSelectedModal}
              setCurrentPath={setCurrentPath}
              currentPath={currentPath}
              setSelectedFolder={setSelectedFolder}
              selectedFolder={selectedFolder}
              setSelectedFile={setSelectedFile}
              selectedFile={selectedFile}
              setModal={setModal}
              setFilesList={setFilesList}
              modal={modal}
              taskManager={taskManager}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              totalPages={totalPages}
              listedFolders={listedFolders}
              getReanderingList={getReanderingList}
            />
          </div>

          {modal &&
            filesList.length > 0 &&
            (isMobile ? (
              <Drawer
                leftButtonWith="50%"
                rightButtonWith="50%"
                submitBtnText="Upload"
                isVisible={modal}
                showHeader={false}
                handleSave={checkTheExistenceOfFile}
                handleCancel={() => {
                  setFilesList([]);
                  // setSelectedFile(null);
                  setModal(false);
                }}
              >
                <UploadFileContent
                  files={filesList}
                  setFilesList={setFilesList}
                  setSelectedFile={setSelectedFile}
                  setIsDropDownVisible={setAddFile}
                  progress={progress}
                  timeRemaining={timeRemaining}
                />
              </Drawer>
            ) : (
              <Modal
                showHeader={false}
                handleSave={checkTheExistenceOfFile}
                handleCancel={() => {
                  setFilesList([]);
                  // setSelectedFile(null);
                  setModal(false);
                }}
              >
                <UploadFileContent
                  files={filesList}
                  setFilesList={setFilesList}
                  setSelectedFile={setSelectedFile}
                  setIsDropDownVisible={setAddFile}
                  progress={progress}
                  timeRemaining={timeRemaining}
                />
              </Modal>
            ))}

          {uploadModal &&
            (isMobile ? (
              <Drawer
                leftButtonWith="50%"
                rightButtonWith="50%"
                isVisible={uploadModal}
                showHeader={false}
                showFooter={false}
              >
                <UploadDropDown
                  cancelUploadModal={cancelUploadModal}
                  showLoadingProgress={showLoadingProgress}
                  filesList={filesList}
                  setUploadModal={setUploadModal}
                  setFilesList={setFilesList}
                  setUploadedFiles={setUploadedFiles}
                  setCancelUploadModal={setCancelUploadModal}
                  setShowLoadingProgress={setShowLoadingProgress}
                  progress={progress}
                  timeRemaining={timeRemaining}
                  selectedFile={selectedFile}
                  setSelectedFile={setSelectedFile}
                  currentPath={currentPath}
                />
              </Drawer>
            ) : (
              <UploadDropDown
                cancelUploadModal={cancelUploadModal}
                setShowLoadingProgress={setShowLoadingProgress}
                filesList={filesList}
                setUploadModal={setUploadModal}
                setFilesList={setFilesList}
                setUploadedFiles={setUploadedFiles}
                showLoadingProgress={showLoadingProgress}
                setCancelUploadModal={setCancelUploadModal}
                progress={progress}
                timeRemaining={timeRemaining}
                selectedFile={selectedFile}
                setSelectedFile={setSelectedFile}
                currentPath={currentPath}
              />
            ))}

          {/* {isMobile &&
            !hasTrueValue &&
            (!AddFile && !showLoadingProgress ? (
              <button className="mobileButton" onClick={handleAddFile}>
                <img src={plusImg} alt="add" />
              </button>
            ) : null)} */}

          {cancelUploadModal && (
            <Modal
              submitBtnText="Cancel"
              closeBtnTxt="Discard"
              showFooter={true}
              // customClass="modalFooter"
              // width="70%"
              handleCancel={() => {
                setUploadModal(true);
                setCancelUploadModal(false);
              }}
              handleSave={() => setCancelUploadModal(false)}
            >
              <div className="modalContent">
                <p className="title">
                  Are you sure you want to cancel all uploads?
                </p>
                <p className="description">
                  Uploads still in progress. Do you want to cancel them all?
                </p>
              </div>
            </Modal>
          )}

          {!TaskMonitorVisible && (
            showLoadingProgress ? (
              <CircleLoading
                handleOpen={() => {
                  setShowLoadingProgress(false);
                  setUploadModal(true);
                }}
              />
            ) : (
              <CircleLoading
                taskManager={taskManager}
                handleOpen={() => {
                  setTaskMonitorVisible(true);
                }}
              />
            )
          )}
        </div>}
      </div>
    );
  }
);
export default memo(FilesWrapperExternal);
